// Re-export datetime utilities
export * from './datetime/index.js';
// Re-export address utilities
export * from './address/index.js';
// Hardcoded version helper; manually update this string when releasing
export const getLibraryVersion = () => "1.3.5";
//# sourceMappingURL=index.js.map